import styled from 'styled-components';

export const UiHeader = styled.div`
	width: 100%;
`;

export const UiMain = styled.div`
	display: flex;
`;

export const UiAside = styled.div`
	flex: 1;
`;

export const UiContent = styled.div`
	display: flex;
	padding: 1rem;
	min-height: 100vh;
	flex: 9;
	flex-direction: column;

	& > div {
		display: flex;
		height: 100%;
		flex-direction: column;
	}
`;
